/**
 * Map BigCommerce payment method ids to the human-readable labels the
 * analytics team expects in Segment. Falls through to the raw id for
 * methods we haven't normalised yet.
 *
 * Convention: brand-faithful CamelCase, no spaces (mirrors the legacy
 * `GooglePay` / `ApplePay` labels Segment already receives). Keep this
 * in sync with the contract documented in `TRACKING_EVENTS_AUDIT.md`
 * -- adding a new label here is the single place every order/payment
 * tracker normalises through.
 */
export var formatPaymentMethodLabel = function formatPaymentMethodLabel(paymentMethod) {
  switch (paymentMethod) {
    case "googlepaystripeupe":
      return "GooglePay";
    case "applepay":
      return "ApplePay";
    case "afterpay":
      return "Afterpay";
    case "clearpay":
      return "Clearpay";
    case "paypalcommerce":
      return "PayPal";
    case "paypalcommercecredit":
      return "PayPalCredit";
    case "paypalcommercecreditcards":
      return "PayPalCreditCards";
    case "stripeupe":
      return "Card";
    default:
      return paymentMethod;
  }
};